import * as React from 'react';
export function useCurrentBreakPoint(breakPoints) {
    const [breakPoint, setBreakPoint] = React.useState(null);
    React.useEffect(() => {
        const resizeListener = () => {
            const sortedBreakPoints = Object.keys(breakPoints).sort((x, y) => breakPoints[y] - breakPoints[x]);
            const bp = sortedBreakPoints.find((breakPoint) => window.matchMedia(`(min-width: ${breakPoints[breakPoint]}px)`).matches);
            setBreakPoint(bp || 'xs');
        };
        window.addEventListener('resize', resizeListener);
        resizeListener();
        return () => {
            window.removeEventListener('resize', resizeListener);
        };
    }, [breakPoints]);
    return breakPoint;
}
